import { ApisauceInstance } from 'apisauce';

const postQueueContentSharedEmails = (
  api: ApisauceInstance,
  usersAddedIds: string[],
) => api.post(`/v1/share/queue_email/`, { usersAddedIds });

export default postQueueContentSharedEmails;
